export default __webpack_public_path__ + "static/media/default_token_placeholder.5a319af1.svg";